
import { makeObservable, observable, runInAction, action, makeAutoObservable } from 'mobx';
import { InvoiceServices } from '../services/invoiceServices';
import i18n from 'i18next';
import { toast } from "react-toastify";
import { WinbizServices } from '../services/winbizServices';

export default class WinbizStore {
 
    rootStore;
    config = {};
    constructor(rootStore) {
        this.rootStore = rootStore;

        makeObservable(this, {
            config:observable,
            saveConfig: action,
            getConfig: action,     
            syncWinbiz: action,
            syncInvoiceWinbiz:action
        });
    }

    saveConfig = async (config, onSuccess) => {

        try {            
            const data = await WinbizServices.setConfig(config);
            runInAction(() => {
                if (onSuccess) { onSuccess() };                
                toast.success(`${i18n.t("winbizConfigSaved")}`);
            });
        } catch (error) {            
            /*runInAction(() => {
                toast.error(i18n.t(error || "errorOcurred"));
            });*/
        }
    }

    getConfig = async () => {

        try {

            const data = await WinbizServices.getConfig();
            runInAction(() => {
                this.config = data;
            });
        } catch (error) {
            /*runInAction(() => {
                toast.error(i18n.t(error || "errorOcurred"));
            });*/
        }
    }

    syncWinbiz = async (id, onSuccess) => {

        try {

            const data = await WinbizServices.syncInvoices(id);
            runInAction(() => {
                if (onSuccess) { onSuccess() };
                toast.success(`${i18n.t("invoiceSynced")}`);
            });
        } catch (error) {
            console.log(error)
            /*runInAction(() => {
                toast.error(i18n.t(error || "errorOcurred"));
            });*/
        }
    }

    syncInvoiceWinbiz = async (id, onSuccess,onError) => {

        try {

            const data = await WinbizServices.syncInvoice(id);
            runInAction(() => {
                if (onSuccess) { onSuccess() };
                toast.success(`${i18n.t("invoiceSynced")}`);
            });
        } catch (error) {
            if (onError) { onError() };
            //console.log(error)
            /*runInAction(() => {
                toast.error(i18n.t(error || "errorOcurred"));
            });*/
        }
    }

    syncWages = async (id, onSuccess) => {

        try {

            const data = await WinbizServices.syncWages(id);
            runInAction(() => {
                if (onSuccess) { onSuccess() };
                toast.success(`${i18n.t("wagesSynced")}`);
            });
        } catch (error) {
            console.log(error)
            /*runInAction(() => {
                toast.error(i18n.t(error || "errorOcurred"));
            });*/
        }
    }

    syncExpenses = async (year,month,devId, onSuccess) => {
        try {
            const data = await WinbizServices.syncExpenses(year,month,devId);
            runInAction(() => {
                if (onSuccess) { onSuccess() };
                toast.success(`${i18n.t("expensesSynced")}`);
            });
        } catch (error) {
            console.log(error)            
        }
    }

    syncExpensesAccounting = async (year, month, devId, onSuccess) => {
        try {
            const data = await WinbizServices.syncExpensesAccounting(year, month, devId);
            runInAction(() => {
                if (onSuccess) { onSuccess() };
                toast.success(`${i18n.t("expensesSynced")}`);
            });
        } catch (error) {
            console.log(error)
        }
    }

    syncExpensesSalary = async (year, month, devId, onSuccess) => {
        try {
            const data = await WinbizServices.syncExpensesSalary(year, month, devId);
            runInAction(() => {
                if (onSuccess) { onSuccess() };
                toast.success(`${i18n.t("expensesSynced")}`);
            });
        } catch (error) {
            console.log(error)
        }
    }

    syncExpensesPurchasing = async (year, month, devId, onSuccess) => {
        try {
            const data = await WinbizServices.syncExpensesPurchasing(year, month, devId);
            runInAction(() => {
                if (onSuccess) { onSuccess() };
                toast.success(`${i18n.t("expensesSynced")}`);
            });
        } catch (error) {
            console.log(error)
        }
    }


   

}